module.exports = __webpack_public_path__ + "static/img/banner-bienvenidos-1680x1050.da2fff4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/banner-bienvenidos-1680x1050.jpg
// module id = 8N0q
// module chunks = 47